import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class UpdateTownCommand implements IMessage {
    id!: Guid;
    code!: string;
    name!: string;
    departmentId!: Guid;

    public constructor(init?: Partial<UpdateTownCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/towns/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            code: this.code,
            name: this.name,
            departmentId: this.departmentId,
        };
    }
}